import { cn } from '@heroui/react';
import { FC } from 'react';

import Links from './components/Links';
import Menu from './components/Menu';
import Select from './components/Select';
import SubHeader from './components/SubHeader';
import * as Elements from './Header.elements';

import { usePlatformLogo } from '~/common/hooks/usePlatformLogo';
import { useHeaderContext } from '~/components/HeaderProvider';

interface HeaderProps {
  byId: {
    [key: string]: {
      id: string;
      name: string;
      companyName: string;
    };
  };
  goToDefaultLayout: () => void;
  goToAdmin: () => void;
  goToConnectivity: () => void;
  allIds: string[];
  activeRealm: {
    realm: string;
  };
  containPaths: () => void;
  setModalNewPassword: () => void;
  setModalTwoFactor: () => void;
  onSignOut: () => void;
  user: { email: string };
  goToSettings: () => void;
  environments: string[];
  eula: object;
  pathNameRuntime: string;
  getEnvriomentByFeatureFlag: () => void;
  links: any[];
  environmentSelectRouteWhiteList?: string[];
}

const Header: FC<HeaderProps> = ({
  allIds = [],
  byId = {},
  activeRealm,
  containPaths,
  setModalNewPassword,
  setModalTwoFactor,
  onSignOut,
  user,
  goToDefaultLayout,
  goToSettings,
  environments,
  eula,
  goToAdmin,
  pathNameRuntime,
  getEnvriomentByFeatureFlag,
  goToConnectivity,
  links,
  environmentSelectRouteWhiteList
}) => {
  const { headerLogo, isPowered } = usePlatformLogo();

  const { configActionButton } = useHeaderContext();

  return (
    <Elements.Container>
      <div className={cn('mb-[5px] flex pl-6 pr-4', 'pt-6')}>
        <div className='mt-2 flex w-1/4 flex-col items-start'>
          <Select allIds={allIds} byId={byId} activeRealm={activeRealm.realm} />
        </div>
        <div className='mt-2 flex w-1/2 flex-col items-center'>
          <img
            src={headerLogo}
            alt='Digibee Logo'
            className={cn('cursor-pointer', !isPowered ? 'w-[190px]' : 'pr-3')}
          />
        </div>
        <div className='mt-2 flex w-1/4 flex-col items-end'>
          <Links
            setModalTwoFactor={setModalTwoFactor}
            setModalNewPassword={setModalNewPassword}
            onSignOut={onSignOut}
            email={user?.email}
            goToDefaultLayout={goToDefaultLayout}
            goToSettings={goToSettings}
            goToAdmin={goToAdmin}
            goToConnectivity={goToConnectivity}
            eula={eula}
          />
        </div>
      </div>
      <div className='w-full'>
        <Menu
          containPaths={containPaths}
          realm={activeRealm.realm}
          environments={environments}
          pathNameRuntime={pathNameRuntime}
          getEnvriomentByFeatureFlag={getEnvriomentByFeatureFlag}
        />
      </div>
      <SubHeader
        links={links}
        activeRealm={activeRealm}
        configActionButton={configActionButton}
        environments={environments}
        environmentSelectRouteWhiteList={environmentSelectRouteWhiteList}
      />
    </Elements.Container>
  );
};

export default Header;
